import { render, staticRenderFns } from "./SendLetterDocumentStep.vue?vue&type=template&id=1b351972&"
import script from "./SendLetterDocumentStep.vue?vue&type=script&lang=js&"
export * from "./SendLetterDocumentStep.vue?vue&type=script&lang=js&"
import style0 from "./SendLetterDocumentStep.vue?vue&type=style&index=0&id=1b351972&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports